// extracted by mini-css-extract-plugin
module.exports = {"dropdownContent":"_2vlrig76","topSlide":"_2lXIHirv","isActiveFocus":"AsfQQWdv","bottomSlide":"l0f78qHd","isOverSized":"_3BzOaauf"};